export const ORDERED_INCLUSIONS_WHITELIST = [
  { code: 'all_inclusive', icon: 'allInclusive' },
  { code: 'tour', icon: 'flag' },
  { code: 'upgrade', icon: 'arrowUpward' },
  { code: 'club_access', icon: 'localPlay' },
  { code: 'transfers', icon: 'directionsBus' },
  { code: 'food_beverage_credit', icon: 'redeem' },
  { code: 'breakfast', icon: 'freeBreakfast' },
  { code: 'dinner', icon: 'restaurant' },
  { code: 'lunch', icon: 'restaurant' },
  { code: 'late_checkout', icon: 'accessTime' },
  { code: 'early_checkin', icon: 'earlyCheckin' },
  { code: 'kids_eat_free', icon: 'childCare' },
  { code: 'valet_parking', icon: 'valetParking' },
  { code: 'mini_bar', icon: 'minibar' },
  { code: 'spa_treatment', icon: 'spa' },
  { code: 'spa_voucher', icon: 'spa' },
  { code: 'kids_stay_free', icon: 'accessibility' },
  { code: 'bottle_of_wine', icon: 'bottleOfWine' },
  { code: 'parking', icon: 'localParking' },
  { code: 'welcome_drink', icon: 'localBar' },
  { code: 'welcome_gift', icon: 'welcomeGift' },
  { code: 'internet', icon: 'wifi' },
];
